import React from 'react'
import { ChevronsRight } from 'lucide-react'

import type { Cta5Block as Cta5BlockProps } from '@/payload-types'
import type { Media as MediaType } from '@/payload-types'

import RichText from '@/components/RichText'
import { Media } from '@/components/Media'
import { CMSLink } from '@/components/Link'

export const Cta5Block: React.FC<
  Cta5BlockProps & {
    id?: string
    blockName?: string
    blockType: 'cta5'
  }
> = ({ image, title, description, links }) => {
  return (
    <section>
      <div className="container">
        <div className="flex w-full flex-col overflow-hidden rounded-lg bg-muted md:rounded-xl lg:flex-row lg:items-center">
          <div className="w-full shrink-0 self-stretch lg:w-1/2">
            {image && (
              <Media
                resource={image as MediaType}
                imgClassName="aspect-3/2 w-full rounded-t-md object-cover md:rounded-t-none md:rounded-l-md"
                alt={typeof image === 'object' && image?.alt ? image.alt : 'CTA image'}
              />
            )}
          </div>
          <div className="w-full shrink-0 px-4 py-6 md:p-8 lg:w-1/2 lg:px-16">
            {title && (
              <div className="mb-3 text-2xl font-semibold md:mb-4 md:text-4xl lg:mb-6">
                <RichText data={title} enableGutter={false} enableProse={false} />
              </div>
            )}
            {description && (
              <div className="mb-8 text-muted-foreground lg:text-lg">
                <RichText data={description} enableGutter={false} enableProse={false} />
              </div>
            )}
            {links && links.length > 0 && (
              <div>
                {links.map((item: any, i: number) => (
                  <div key={i} className="relative overflow-hidden group rounded-full inline-flex">
                    <CMSLink
                      {...item.link}
                      className="z-10 inline-flex items-center border border-primary text-primary-foreground bg-primary hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-3"
                      aria-label={item.link.label || 'Get Started'}
                    >
                      {item.link.label || 'Get Started'}
                      <div className="w-8 h-8 rounded-full flex items-center justify-center ml-2 bg-primary text-primary-foreground">
                        <ChevronsRight className="size-4" />
                      </div>
                    </CMSLink>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
